import React from 'react';
import { TextInput } from 'react-admin';

const TRUNCATE_LENGTH = 10; // Signed integer max length
const buildLabel = (label) => `${label ?? 'ID'} (Limit ${TRUNCATE_LENGTH} characters)`;

const truncateToChars = (value: string) =>
  value ? Number(value.slice(0, TRUNCATE_LENGTH)) : value;

const IdInput = (props) => (
  <TextInput
    data-testid="id-input"
    {...props}
    label={buildLabel(props.label)}
    parse={truncateToChars}
  />
);

IdInput.defaultProps = {
  alwaysOn: true,
  source: 'id',
  label: 'ID',
  resettable: true,
};

export default IdInput;
